<template>
  <div>
    <b-table striped small hover :items="baseEtymsData">
      <template #cell(action)="data">
        <div class="text-right">
          <router-link :to="{ name: 'BaseEtymDetails', params: {
            id: data.item.id
          }}">
            <b-icon icon="link45deg"></b-icon>
          </router-link>
          <a
            href="#"
            v-if="editMode"
            @click="editRow($event, data.item.action.baseEtym)"
            ><b-icon icon="pencil"></b-icon
          ></a>
          <a href="#" v-if="editMode" @click="deleteRow($event, data.item.id)"><b-icon icon="trash"></b-icon></a>
        </div>
      </template>
      <template #cell(id)="data">
        <tdColUUID :value="data.item.id" />
      </template>
    </b-table>
    <b-col sm="4" md="3" v-if="showTotalLable">
      Total {{ baseEtymsData.length }} {{ baseEtymsData.length === 1 ? 'entry' : "entries" }} in table
    </b-col>
  </div>
</template>

<style scoped>
  * >>> th {
    font-size: 10px !important;
    text-transform: uppercase;
    color: #bbbbbb;
  }
</style>

<script>
  import tdColUUID from '@/components/tdColUUID.vue'

  export default {
    name: 'BaseEtymTable',
    props: ['baseEtyms', 'editMode', 'showTotal'],
    data(){
      return {
        showTotalLable: this.showTotal ? this.showTotal : false
      }
    },
    components: {
      tdColUUID
    },
    computed: {
      baseEtymsData(){
        return this.baseEtyms.map((baseEtym, index) => {
          baseEtym['_index'] = index;
          return {
            id: baseEtym.id,
            form: baseEtym.form,
            comment: baseEtym.comment,
            ordering: baseEtym.ordering,
            action: {
              baseEtym: baseEtym
            },
          }
        }).sort((a, b) => {
          if (a.ordering < b.ordering) return -1;
          if (a.ordering > b.ordering) return 1;
          return 0;
        })
      }
    },
    methods: {
      deleteRow(event, id){
        event.preventDefault()
        this.$emit('delete', id)
      },
      editRow(event, baseEtym) {
        event.preventDefault();
        this.$emit("edit", baseEtym);
      },
    }
  }
</script>
